module.exports = __webpack_public_path__ + "static/img/product-5.ede3005.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product-5.png
// module id = RsS/
// module chunks = 0